
export function getSkillId (skills, skillName) {
    return getSkill(skills, skillName)?.skillId;
}

export function getSkill (skills, skillName) {
    return skills.find(s => s.name.toLowerCase() === skillName.toLowerCase());
}

export function addStaticSkills (existingSkills = [], availableSkills = []) {
    const staticSkills = availableSkills.filter(s => s.skillset === 8 && s.tier === 0);
    const purchasedSkillIds = existingSkills.map(s => s.skillId);
    const skillsToAdd = staticSkills.reduce((acc, skill) => {
        if (!purchasedSkillIds.includes(skill.skillId)) {
            acc.push({
                skillId: skill.skillId,
                ranks: 1
            });
        }
        return acc;
    }, []);

    return [...existingSkills, ...skillsToAdd];
}

